import { useEffect, useState } from "react";
import { useImx } from "../contexts/ImxContext";
import { handleError } from "../utils/utils";

export default function useFarmingBunnies() {
  const { account, localDatabase } = useImx();
  const [farmingBunnies, setFarmingBunnies] = useState();

  useEffect(() => {
    const loadFarmingBunnies = async () => {
      const farmingBunnies = await localDatabase.getFarmingBunnies(account);
      setFarmingBunnies(farmingBunnies);
    };

    const refresh = (e) => {
      loadFarmingBunnies().catch(handleError);
    };

    refresh();
    localDatabase.onFarmingBunnyChange(refresh);
    return () => {
      localDatabase.offFarmingBunnyChange(refresh);
    };
  }, [account]);

  return farmingBunnies;
}
